import React, { FC } from "react";
import { Link } from "react-router-dom";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
import { Dropdown } from "react-bootstrap";
import { People, Sliders2, ThreeDots, Trash } from "react-bootstrap-icons";
import ImgProject from "../projectsList/img/project.png";
import { useTranslation } from "react-i18next";

type Props = {
  projects: any;
  handleShowDeleteModal: (project: any) => void;
  loading: boolean;
};

export const ProjectListGrid: FC<Props> = ({
  projects,
  handleShowDeleteModal,
  loading,
}) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();

  return (
    <div className="container my-4 px-0">
      <div className="row">
        {projects.length > 0 ? (
          projects.map((project: any) => (
            <div
              key={project.id}
              className="col-md-4 text-dark text-decoration-none"
            >
              <div
                className={`bg-white rounded-4 mb-4 text-decoration-none ${loading && "disabled-block"}`}
              >
                <Link
                  to={`${lng}/projects/${project.id}`}
                  className="text-center pt-3 px-3 d-block"
                >
                  <div
                    className={`border rounded-2 overflow-hidden ${!project?.firstPage?.image && "d-flex justify-content-center"}`}
                    style={{ height: "186px" }}
                  >
                    <img
                      className={`${project?.firstPage?.image ? "img-fluid w-100" : "h-100"}`}
                      src={project?.firstPage?.image || ImgProject}
                      alt={`Project: ${project.title}`}
                    />
                  </div>
                </Link>
                <div className="d-flex align-items-center justify-content-between">
                  <Link
                    to={`${lng}/projects/${project.id}`}
                    className="text-decoration-none d-block w-75 py-3 ps-3 overflow-hidden"
                  >
                    <div>
                      <h5 className="text-dark-gray mb-1 fs-4 text-nowrap overflow-ellipsis overflow-hidden">
                        {project.title}
                      </h5>
                      <p className="m-0 text-gray fs-7">
                        {project?.countDomainFolders || 0} {t("share.folders")}{" "}
                        {project?.countDomainPages || 0} {t("share.pages")}
                      </p>
                    </div>
                  </Link>
                  <Dropdown className="pe-3">
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      className="bg-transparent border-0"
                    >
                      <ThreeDots size={24} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        className="py-2 px-3 mb-1"
                        as={Link}
                        to={`${lng}/projects/${project.id}/edit`}
                      >
                        <Sliders2 className="me-2" />
                        {t("projects.settings")}
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="py-2 px-3 mb-1"
                        as={Link}
                        to={`${lng}/user/access/domain/${project.id}/access`}
                      >
                        <People className="me-2" />
                        {t("share.title")}
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="py-2 px-3 mb-1"
                        href="#"
                        onClick={() => handleShowDeleteModal(project)}
                      >
                        <Trash className="me-2" />
                        {t("projects.delete")}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>{t("projects.noSearch")}</p>
        )}
      </div>
    </div>
  );
};
